module.exports = __webpack_public_path__ + "static/media/vegitables_41.b9636cd3.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_41.csv
// module id = 626
// module chunks = 0